import { motion } from 'framer-motion';
import { Icon } from '@iconify/react';
import { portfolioData } from '../../data/portfolioData';

const Experience = ({ staggerItem }) => {
  return (
    <section id="experience" className="py-20 border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 transition-colors duration-300">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl font-bold text-gray-900 dark:text-white text-center mb-16">
          <span className="underline-3d">Skúsenosti</span>
        </h2>
        
        <div className="relative border-l-2 border-blue-600/30 dark:border-blue-400/20 max-w-4xl mx-auto pl-8 sm:pl-12">
          {portfolioData.experience.map((exp, index) => (
            <motion.div 
              key={index}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
              variants={staggerItem}
              className="mb-16 last:mb-0 relative group"
            >
              <div className="absolute -left-[41px] sm:-left-[57px] top-0 w-6 h-6 bg-white dark:bg-gray-900 border-4 border-blue-600 rounded-full group-hover:scale-125 transition-transform duration-300" />
              
              <div className="bg-gray-50/50 dark:bg-gray-800/40 p-6 sm:p-8 rounded-2xl border border-gray-200 dark:border-gray-700/50 hover:border-blue-600/50 transition-all duration-500 shadow-xl hover:shadow-2xl hover:shadow-blue-600/10 hover:-translate-y-1 text-left">
                <span className="text-blue-500 font-mono text-sm mb-2 flex items-center gap-2">
                  <Icon icon="mdi:calendar-range" className="text-base" />
                  {exp.period}
                </span>
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white mb-2">{exp.company}</h3>
                <p className="text-lg text-gray-600 dark:text-gray-400 font-medium mb-4">{exp.role}</p>
                
                {exp.description && <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">{exp.description}</p>}
                
                <div className="flex flex-wrap gap-2">
                  {exp.skills.map((skill, si) => (
                    <motion.span 
                      key={si}
                      whileHover={{ 
                        backgroundColor: '#2563eb',
                        color: '#fff',
                        borderColor: '#2563eb'
                      }}
                      transition={{ duration: 0.2, ease: "easeOut" }}
                      className="px-3 py-1 bg-gray-100 dark:bg-gray-800 text-xs text-gray-700 dark:text-gray-300 rounded-full border border-gray-200 dark:border-gray-700 cursor-default"
                    >
                      {skill}
                    </motion.span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
